import React from 'react';
import clsx from 'clsx';
import { ErrorMessage, useFormikContext } from 'formik';
import type { ErrorMessageProps } from 'formik';

interface IErrorMsg extends Omit<ErrorMessageProps, 'name'> {
  name: string | string[];
}

export function FormErrorMsg(props: IErrorMsg) {
  const formikContext = useFormikContext();

  if (typeof props.name === 'string') {
    return (
      <div className={clsx('error form-error invalid-feedback', props.className)}>
        <ErrorMessage {...props} name={props.name} />
      </div>
    );
  }

  for (let i = 0; i < props.name.length; i++) {
    const fieldName = props.name[i];
    const field = formikContext.getFieldMeta(fieldName);

    if (field.error && field.touched) {
      return (
        <div className={clsx('error form-error invalid-feedback', props.className)}>
          <ErrorMessage {...props} name={fieldName} />
        </div>
      );
    }
  }

  return <></>;
}
